const WodaOdczytyRazemSzczegolyEdytujOpis = props => {

    const { edytowanyZakres } = props;

    return (
        <div className="row">
            <p className="opis tytul">
                {edytowanyZakres.opis}
            </p>
        </div>
    )
}

export default WodaOdczytyRazemSzczegolyEdytujOpis;